import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { catchError, Observable, of } from 'rxjs';

import {
  Transaction,
  TransactionStatus,
} from 'src/app/models/transaction.interface';

import { Payment } from 'src/app/models/payment';
import { Utility } from 'src/app/helpers/utility-helper';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  constructor(
    private http: HttpClient
  ) {
    this.transaction = {
      discountTotal: '',
      grandTotal: '',
      refundedTendersTotalAmount: '',
      balanceDueCurrencyFormat: '',
      balanceDueFixedPointFormat: '',
      subtotal: '',
      taxTotal: '',
      tendersTotalAmount: '',
      totalDue: '',
      transactionDiscounts: [
        {
          amount: '',
          discountDescription: '',
          rate: ''
        },
      ],
      transactionItems: [
        {
          amount: '',
          discountTotal: '',
          isDiscounted: false,
          taxable: '',
          modifiers: [
            {
              amount: '',
              name: ''
            }
          ],
          modifierTotal: '',
          name: '',
          quantity: 0,
          taxTotal: '',
          unitPrice: '',
          unitOfMeasure: '',
        },
      ],
      transactionNotes: [
        {
          note: ''
        }
      ],
      transactionStatusTypeId: 0,
      transactionTypeId: 0,
      transactionTaxes: [
        {
          amount: '',
          name: '',
          rate: ''
        }
      ],
      transactionTenders: [
        {
          localCompletionDate: '',
          paymentTypeId: 0,
          paymentCardTypeId: 0,
          redactedInfo: '',
          amountReceived: '',
          tenderType: ''
        }
      ],
      currencyCode: ''
    };

    this.transactionStatusItems = {
      primaryText: '',
      secondaryText: '',
      statusLabel: '',
      statusColor: ''
    };
  }

  public transaction: Transaction;
  public transactionStatusItems: TransactionStatus;

  getTransaction(transactionId: number): Observable<Transaction> {
    return this.http.get<Transaction>(
      'api/transactions/' + transactionId
    );
  }

  setTransaction(transaction: Transaction): void {
    this.transaction = transaction;
  }

  postTransactionNote(
    transactionId: number,
    note: string,
    metaData: string,
    noteTypeId: number,
    localCurrentDate: string
  ): Observable<any> {
    return this.http
      .post('api/transactions/' + transactionId + '/notes', {
        note: note + localCurrentDate,
        MetaData: metaData,
        noteTypeId,
      })
      .pipe(catchError(() => Utility.okHttpResponse()));
  }

  postTransaction(paymentInfo: Payment): Observable<any> {
    return this.http.post(
      'api/transactions/' + paymentInfo.transactionId + '/sale',
      paymentInfo
    );
  }

  setTransactionStatusItems(transactionStatusItems: TransactionStatus): void {
    this.transactionStatusItems = transactionStatusItems;
  }

  postNotification(notificationInfo: any): Observable<any> {
    return this.http.post(
      'api/transactions/notification',
      {
        TransactionId: notificationInfo.TransactionId,
        NotificationChannelTypeIds: notificationInfo.NotificationChannelTypeIds,
        Phone: notificationInfo.Phone,
        Email: notificationInfo.Email,
        TransactionNotificationTypeId: notificationInfo.TransactionNotificationTypeId,
        LanguageCode: notificationInfo.LanguageCode,
      }
    );
  }
}
